import { render, staticRenderFns } from "./ClientsDetail.vue?vue&type=template&id=67a1fdde&"
import script from "./ClientsDetail.vue?vue&type=script&lang=js&"
export * from "./ClientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDetail.vue?vue&type=style&index=0&id=67a1fdde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports